<template>
    <div id="thread-summary-chat" v-if="!!selectedChat">
        <div class="head">
            <!--            <Avatar
                            :size="55"
                            :username="thread.name || ''"
                            :src="thread.gravatar"
                            class="sc-message&#45;&#45;avatar"
                            style="color: white; font-size: 15px"
                        />-->
            <AgentAvatar :size="82" :font-size="17" :userID="thread._id" :is-named="true" />
        </div>

        <MediaSlide v-if="mediaSlideVisible" @close-media-slide="mediaSlideVisible = false" />

        <div class="user-info" v-else>
            <div class="media-row" @click="mediaSlideVisible = true">
                <span class="media-text">{{ $t("message.sumChat_MediaFile") }}</span>
                <span class="material-icons media-btn">arrow_forward</span>
            </div>
            <span class="user-info-head">{{ $t("message.userInformations") }}</span>
            <div
                class="user-info-item"
                v-for="data in datas"
                v-if="
                    data.slot !== 'lastLoginUserAgent' ||
                    (data.slot === 'lastLoginUserAgent' && thread.lastLoginUserAgent)
                "
            >
                <span class="info-right" v-if="getSlot(data.slot) !== null">
                    <div class="info-name">{{ data.name }}</div>
                    <div class="icon-content-container">
                        <div>
                            <span class="material-icons" style="color: #ec4a1d; font-size: 22px; max-width: 22px">
                                {{ data.icon }}
                            </span>
                        </div>

                        <div
                            class="info-content"
                            :title="
                                data.slot === 'email'
                                    ? getSlot(data.slot)
                                    : data.slot === 'name'
                                    ? getSlot(data.slot)
                                    : null
                            "
                        >
                            {{ getSlot(data.slot) }}
                            <UserAgentInfo
                                v-if="
                                    data.slot === 'lastLoginUserAgent' &&
                                    !lastLoginUserAgentComputed &&
                                    thread.lastLoginUserAgent
                                "
                                :user-agent="thread.lastLoginUserAgent"
                                :os="os"
                                :browser="browser"
                                :browser-version="browserVersion"
                            />
                        </div>
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import Avatar from "vue-avatar";
import MediaSlide from "./MediaSlide";
import UserAgentInfo from "./UserAgentInfo.vue";
import parser from "ua-parser-js";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";

const log = log2("ThreadSummaryChat");

export default {
    name: "ThreadSummaryChat",
    components: { Avatar, MediaSlide, UserAgentInfo, AgentAvatar },
    props: {},
    data() {
        return {
            lastLoginUserAgentComputed: false,
            os: "",
            browser: "",
            browserVersion: "",
            datas: [
                {
                    name: this.$t("userInfoWidget.fullName"),
                    slot: "name",
                    icon: "person",
                },
                {
                    name: this.$t("message.email"),
                    slot: "email",
                    icon: "email",
                },
                {
                    name: this.$t("message.country") + " " + this.$t("message.language"),
                    slot: "lang",
                    icon: "language",
                },
                {
                    name: this.$t("message.lastLoginPlatform"),
                    slot: "lastLoginPlatform",
                    icon: "settings_suggest",
                },
                {
                    name: "IP",
                    slot: "lastLoginIPAddress",
                    icon: "room",
                },
                {
                    name: this.$t("message.os_browser"),
                    slot: "lastLoginUserAgent",
                },
            ],
            thread: [],
            mediaSlideVisible: false,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            selectedChat: (state) => state.team.selectedChat,
        }),
    },
    methods: {
        getSlot(slot) {
            if (slot === "lastLoginUserAgent") {
                if (!this.lastLoginUserAgentComputed) {
                    const userAgent = this.thread[slot];
                    const osAndBrowser = userAgent?.match(/\(([^)]+)\)/);
                    if (osAndBrowser) {
                        const osAndBrowserString = osAndBrowser[1];
                        this.os = this.detectOS(osAndBrowserString);

                        this.browser = this.detectBrowser(userAgent);

                        this.browserVersion = this.getBrowserVersion(userAgent, this.browser);

                        if (this.os === "" && this.browser === "") {
                            this.lastLoginUserAgentComputed = true;
                        }
                    }
                }
            } else {
                return this.thread[slot];
            }
        },
        detectOS(userAgentString) {
            const ua = parser(userAgentString || "-");
            const osInfo = ua.os || {};

            if (osInfo.name) {
                return osInfo.name;
            } else {
                return "";
            }
        },
        getBrowserVersion(userAgentString, browserName) {
            const browserVersionMatch = userAgentString.match(new RegExp(`${browserName}/([\\d.]+)\\s`));
            return browserVersionMatch ? browserVersionMatch[1] : "";
        },
        detectBrowser(userAgentString) {
            const browserInfo = parser(userAgentString || "-").browser || {};
            let browserName = browserInfo.name || "";
            return browserName;
        },
    },
    watch: {
        selectedChat: {
            handler(newVal) {
                if (newVal.meta.thread.agent1._id === this.user._id) {
                    this.thread = newVal.meta.thread.agent2;
                } else {
                    this.thread = newVal.meta.thread.agent1;
                }
            },
            deep: true,
        },
    },
    mounted() {
        if (!!this.selectedChat && !!this.selectedChat.meta && !!this.selectedChat.meta.thread) {
            if (this.selectedChat.meta.thread.agent1._id === this.user._id) {
                this.thread = this.selectedChat.meta.thread.agent2;
            } else {
                this.thread = this.selectedChat.meta.thread.agent1;
            }
        }
    },
};
</script>

<style lang="scss">
#thread-summary-chat {
    overflow-x: hidden !important;
    .head {
        display: flex;
        justify-content: center;
        padding: 10px;
        align-items: end;

        .name-container{
            white-space: nowrap;
            text-overflow: ellipsis;
            b{
                font-size: 17px;
                overflow: hidden;
                display: block;
                width: 100px;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .offlineBorder {
            border: 3px solid #aeaeae;
        }

        .onlineBorder {
            border: 5px solid transparent;
            animation: border-pulsate 2s infinite ease-out;
        }
    }

    @keyframes border-pulsate {
        0% {
            border-color: rgba(102, 194, 102, 1);
        }
        50% {
            border-color: rgba(255, 255, 255, 1);
        }
        100% {
            border-color: rgba(102, 194, 102, 1);
        }
    }

    .user-name {
        font-size: initial;
        font-weight: 600;
        display: flex;
        justify-content: center;
    }

    .user-type {
        font-size: initial;
        font-weight: 200;
        display: flex;
        justify-content: center;
    }

    .user-info {
        margin-top: 62px;
        margin-left: 18px;

        .media-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            cursor: pointer;

            .media-text {
                font-size: 17px;
                font-weight: 600;
                color: #9f8524;
            }

            .media-btn {
                color: #9f8524;
                font-size: 17px;
                max-width: 22px;
                margin-right: 40px;
                font-weight: 600;
            }
        }

        .user-info-head {
            font-weight: 600;
            font-size: medium;
        }

        .user-info-item {
            display: flex;
            margin-top: 20px;
            align-items: center;

            .info-right {
                margin-left: 10px;

                .info-name {
                    font-weight: 400;
                    font-size: smaller;
                    color: #c4c4c4;
                }

                .icon-content-container {
                    display: flex;
                    gap: 3px;
                }

                .info-content {
                    font-weight: 400;
                    width: 130px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }

    &::-webkit-scrollbar {
        display: none !important;
    }
}
</style>
